<div class="submissions-status" *ngIf="submissions_card">
  <div class="row align-items-center m-t--10">
    <div class="col-sm-12 col-lg-6">

      <div class="d-flex align-items-center flexmob">

        <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
        </div>
        <div class="m-l-10 d-flex">

          <div class="m-l-10">
            <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
              Submissions
            </h4>
            <h5 class="f-s-14  text-black-25 m-t-5 ">
              {{AccountingPeriod}}
            </h5>
          </div>
        </div>

      </div>
    </div>
    <div class="col-sm-12 col-lg-6  text-right">
      <div class="d-flex justify-content-end">
        <div class="p-8" style="background-color: #fff; border-radius:10px;">
          <button mat-flat-button class="bg-none m-r-10" [disabled]="!UserRoleAccess?.m1ExportorDownload" (click)="this.ExportasPDFandIXBRL('ExportasPDF', 'ForPDFviwer',template)">
            <div class="d-flex align-items-center">
              <i-tabler class="icon-18 m-r-10" name="eye"></i-tabler>Preview
            </div>
          </button>
          <button mat-flat-button class="bg-none import" (click)="openExport(templateExport)" [disabled]="!UserRoleAccess?.m1ExportorDownload">
            <div class="d-flex align-items-center">
              <i-tabler class="icon-18 m-r-10" name="upload"></i-tabler> Export
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>



  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 m-t-14" *ngIf="Charity_Type != 'Unincorporated Charity'">
        <mat-card class="equal-card">
          <mat-card-content>
            <div class="row card-row p-t-0 b-b-1 m-b-14">
              <div class="col-lg-7 p-r-0">
                <h5 class="f-s-16 f-w-600 heading-text-clr">Companies House</h5>
                <p class="f-s-14 m-t-0 f-w-400">Submit Annual Accounts to Companies House for Regulatory Complaince</p>
              </div>
              <div class="col-lg-5 text-right pb-10">
                <div class="status-success" *ngIf="CompanyHouseSubmissionStatus != 'Failed' && CompanyHouseSubmissionStatus != 'failed' && CompanyHouseSubmissionStatus != 'Not Submitted'">
                  <!--<i-tabler class="icon-16 m-r-4 m-t-2 text-success"></i-tabler>-->
                  <span class="f-s-14 f-w-400" style="white-space: nowrap;">{{CompanyHouseSubmissionStatus}}</span>
                </div>
                <div class="status-failed" *ngIf="CompanyHouseSubmissionStatus == 'Failed' || CompanyHouseSubmissionStatus == 'failed' || CompanyHouseSubmissionStatus == 'Not Submitted'">
                  <!--<i-tabler class="icon-16 m-r-4 m-t-2 text-failed"></i-tabler>-->
                  <span class="f-s-14 f-w-400" style="white-space: nowrap;">{{CompanyHouseSubmissionStatus}}</span>
                </div>
              </div>
            </div>
            <div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submitted Date:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{FBI_StartTimeStamp && FBI_StartTimeStamp.trim() !== '' ? (FBI_StartTimeStamp | date:'dd/MM/yyyy'): '-'}}
                </h5>
              </div>
            </div>
            <div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submitted Time:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ FBI_StartTimeStamp && FBI_StartTimeStamp.trim() !== '' ? (FBI_StartTimeStamp | date:'HH:mm:ss') : '-'}}
                </h5>
              </div>
            </div>
            <div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submitted by:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ (LoginUserName && LoginUserName.trim() !== '' && SubmissionDetails?.length > 0) ? LoginUserName : '-' }}
                </h5>
              </div>
            </div>
            <div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submission Number:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ submissionNumber && submissionNumber.trim() !== '' ? submissionNumber : '-' }}
                </h5>
              </div>
            </div>
            <div class="row p-t-20 b-t-1 action-row">
              <div class="col-lg-6 col-sm-6">
                <button mat-flat-button color="primary" class="bg-edit-btn text-primary" (click)="GetSubmissionStatus()" [disabled]="!UserRoleAccess?.m1Submit || SubmissionDetails?.length == 0 || SubmissionStatus =='Failed'" style="height: 30px;">
                  <span class="" style="white-space: nowrap;"> Retrieve Submissions Status </span>
                </button>
              </div>
              <div class="col-lg-6 col-sm-6 text-right mt-10">
                <button mat-flat-button class="bg-success rounded-5" (click)="SubmitToCH()" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Submit">
                  <div class="d-flex text-black">
                    <span class="f-s-14 text-white" style="white-space: nowrap;">Submit to Companies House</span>
                  </div>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-lg-6 m-t-14" >
        <mat-card class="equal-card">
          <mat-card-content>
            <div class="row card-row p-t-0 b-b-1 m-b-14">
              <div class="col-lg-8">
                <h5 class="f-s-16 f-w-600 heading-text-clr">Charity Commission</h5>
                <p class="f-s-14 m-t-0 f-w-400">Submit Annual Return to the Charity Commission for Charity Registration Complaince</p>
              </div>
              <div class="col-lg-4 text-right pb-10 p0">
                <div class="status-success" *ngIf="this.ccSubmittedDate!='-'&&this.ccSubmittedDate">
                  <!--<i-tabler class="icon-16 m-r-4 m-t-2 text-success"></i-tabler>-->
                  <span class="f-s-14 f-w-400">Submitted</span>
                </div>
                <div class="">
                  <div class="status-failed" *ngIf="this.ccSubmittedDate=='-'">
                    <!--<i-tabler class="icon-16 m-r-4 m-t-2 text-failed"></i-tabler>-->
                    <span class="f-s-14 f-w-400">Not Submitted</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submitted Date:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ccSubmittedDate}}
                </h5>
              </div>
            </div>
            <!--<div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Submitted by:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ccSubmittedBy}}
                </h5>
              </div>
            </div>-->
            <!--<div class="row m-b-8">
              <div class="col-lg-6">
                <h5 class="f-s-14 f-w-400">
                  Reference:
                </h5>
              </div>
              <div class="col-lg-6 text-right">
                <h5 class="f-s-14 f-w-500">
                  {{ccSubmittedRef}}
                </h5>
              </div>
            </div>-->
            <div class="row p-t-20 b-t-1 action-row">
              <div class="col-lg-6 col-sm-6">
                <button (click)="retrieveCharityCumission()" mat-flat-button color="primary" [disabled]="!UserRoleAccess?.m1Submit" class="bg-edit-btn text-primary" style="height: 30px;">
                  <span class="" style="white-space: nowrap;"> Retrieve Submissions Status</span>
                </button>
              </div>
              <div class="col-lg-6 col-sm-6 text-right mt-10">
                <button mat-flat-button color="primary" class="bg-success" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Submit" (click)="SubmitToCC()">
                  <div class="d-flex align-items-center" style="white-space: nowrap;">
                    Submit to Charity Commmission
                  </div>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>

<div class="filing-details" *ngIf="filing_details">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="SubmissionForm">
        <div class="row card-row p-t-0 p-b-20 b-b-1 m-b-14">
          <div class="col-lg-9">
            <h5 class="f-s-16 f-w-600 heading-text-clr">Companies House Software Filing Details</h5>
          </div>
        </div>
        <div class="row m-b-16">
          <div class="col-lg-12">
            <h5 class="f-s-14 f-w-600">
              Enter/Verify details and click 'Submit'
            </h5>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Companies Registration Number
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="bg-white w-100" style="border-radius: 10px;">
              <input matInput type="text" disabled formControlName="RegistrationNumber" />
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Company Authentication Code <span class="text-danger">*</span>
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput [type]="inputType" #passwordInput maxlength="6" (input)="checkValue('CompanyAuthenticationCode')" placeholder="Company Authentication code" formControlName="CompanyAuthenticationCode">
              @if(SubmissionForm.get('CompanyAuthenticationCode')?.hasError('required')){
              <mat-error>Company Authentication Code is required</mat-error>
              }
              @else if(SubmissionForm.get('CompanyAuthenticationCode')?.hasError('invalid')){
              <mat-error style="padding-right:0px">Company Authentication length should be 6</mat-error>
              }
              <mat-icon class="custom-form eye-icon" matSuffix (click)="toggleInputType('CAC')">
                {{ inputType === 'password' ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Submitted as
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="w-100">
              <mat-select value="" class="text-left" formControlName="Submittedas" (selectionChange)="submittedasChange($event)">
                <mat-option *ngFor="let data of submitedlist" value="{{data}}"> {{data}} </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Presenter Contact Name
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="bg-white w-100" style="border-radius: 10px;">
              <input matInput type="text" value="Jacob Williams" placeholder="Presenter Contact Name" formControlName="PresenterContactName" disabled />
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400" (click)="clickPresenterID()">
              Presenter ID <span class="text-danger">*</span>
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class=" w-100" style="border-radius: 10px;">
              <input matInput type="text" formControlName="PresenterID" (input)="handleInput($event);checkValue('PresenterID')" maxlength="11" placeholder="Presenter ID" />
              @if(SubmissionForm.get('PresenterID').hasError('required')){
              <mat-error>Presenter ID is required</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400" (click)="clickPresenterAuthenticationCode()">
              Presenter Authentication Code <span class="text-danger">*</span>
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput [type]="inputType1" #passwordInput placeholder="Presenter Authentication code" maxlength="11" formControlName="PresenterAuthenticationCode" disabled>
              <mat-error *ngIf=" SubmissionForm.get('PresenterAuthenticationCode').hasError('required') && SubmissionForm.get('PresenterAuthenticationCode').invalid">
                Presenter Authentication Code is required
              </mat-error>
              <mat-icon class="custom-form eye-icon" matSuffix (click)="toggleInputType('PAC')">
                {{ inputType1 === 'password' ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400" (click)="clickPresenterEmailAddress()">
              Presenter Email Address <span class="text-danger">*</span>
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class=" w-100" style="border-radius: 10px;">
              <input matInput type="text" placeholder="Presenter Email Address" (input)="checkValue('PresenterEmailAddress')" maxlength="100" formControlName="PresenterEmailAddress" />
              @if(SubmissionForm.get('PresenterEmailAddress').hasError('required')){
              <mat-error>Presenter Email Address is required</mat-error>
              }@else if(SubmissionForm.get('PresenterEmailAddress').hasError('pattern')){
              <mat-error>Enter valid Email Address</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Presenter Contact Number
            </h5>
          </div>
          <div class="col-lg-5 text-right">
            <mat-form-field appearance="outline" class="w-100" style="border-radius: 10px;">
              <input matInput type="text" placeholder="Presenter Contact Number" (input)="checkValue('PresenterContactNumber')" MobileNumber maxlength="20" formControlName="PresenterContactNumber" disabled />
              @if(SubmissionForm.get('PresenterContactNumber').hasError('minLength')){
              <mat-error>Presenter Contact Number length should be between 10 to 20</mat-error>
              }@else if(SubmissionForm.get('PresenterContactNumber').hasError('maxLength')){
              <mat-error>Presenter Contact Number length should be between 10 to 20</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="row m-b-10 align-items-center">
          <div class="col-lg-4">
            <h5 class="f-s-14 f-w-400">
              Do you want to save your Login Credentials?
            </h5>
          </div>
          <div class="col-lg-5 p-l-2 text-left">
            <mat-checkbox class="example-margin" formControlName="SaveCredentials"></mat-checkbox>
          </div>
        </div>
        <div class="row p-t-14">
          <div class="col-lg-9 text-right"  [style.pointer-events]="ShowSpinner ? 'none' : 'auto'">
            <button mat-flat-button color="primary" class="bg-edit-btn text-primary m-r-10" (click)="Backtosubmissionscard()" style="height: 30px;"  >
              <span class=""> Back </span>
            </button>
            <button mat-flat-button class="bg-success rounded-5"  (click)="SubmissionToCompanyHouse()" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Create">

              <div class="d-flex text-black">
                <span class="f-s-14 text-white">Submit</span>
              </div>
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<div class="fbi-page" *ngIf="submissionFBIpage">


  <div class="row align-items-center p-b-10">
    <div class="col-sm-12 col-lg-6">
      <div class="d-flex align-items-center flexmob">
        <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" (click)="BacktoSubmissions()">
          <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Submissions
        </div>
        <div class="m-l-10 d-flex">
          <div>
            <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
              <i-tabler name="database-share" class="icon-28" style="line-height: 30px !important"></i-tabler>
            </button>
          </div>
          <div class="m-l-10">
            <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
              File by Internet
            </h4>
            <h5 class="f-s-14  text-black-25 m-t-5 ">
              {{AccountingPeriod}}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-lg-6  text-right"></div>
  </div>


  <mat-card class="m-t-14">
    <mat-card-content style="padding: 0px !important;">

      <div class="table-responsive rounded-3 mt-4 mx-2 my-2" style="border: 1px solid #ebebeb;">
        <table mat-table [dataSource]="fbiData" class="w-100">
          <ng-container matColumnDef="dateandtime">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Time</th>
            <td mat-cell *matCellDef="let fbiData">
              {{ FBI_StartTimeStamp && FBI_StartTimeStamp.trim() !== '' ? (FBI_StartTimeStamp | date:'HH:mm:ss') : '-'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="requestsent">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Request Sent</th>
            <td mat-cell *matCellDef="let fbiData">
              Accounts_request_request
            </td>
          </ng-container>

          <ng-container matColumnDef="response">
            <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Response Received</th>
            <td mat-cell *matCellDef="let fbiData">
              Accounts_request_{{Qualifier}}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="example-first-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>

    </mat-card-content>
  </mat-card>

  <div class="col-12 m-b-14">
    <div class="card-body p-2">
      <div class="row">
        <div class="FBI-heading">
          <h6 class="f-w-600 m-t-10 f-s-16" style="color: #1b4b6c;">File By Internet - Submission Details</h6>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-start">
    <div class="col-md-8 col-lg-8">
      <mat-card>
        <mat-card-content class="p-t-14">
          <div class="row">
            <div class="col-md-12">
              <div class="card rounded-4">
                <div class="card-body pt-0">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> Charity Name :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{CharityName}}</span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for=" Periodend" class="form-label f-w-600 f-s-14"> Period end:</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{AP_endDate}}</span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for=" Periodend" class="form-label f-w-600 f-s-14"> Submission Type:</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{submissionType}}</span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> Submission Number :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{submissionNumber}}</span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> Transaction ID :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">
                        {{TransactionId}}
                      </span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">

                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> FBI Start Time :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{FBI_StartTimeStamp}}</span>
                    </div>

                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> FBI End Time :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{FBI_EndTimeStamp}}</span>
                    </div>
                  </div>
                  <hr style="opacity: 0.2;">
                  <div class="row m-y-14">
                    <div class="col-md-4">
                      <label for="CompanyName" class="form-label f-w-600 f-s-14"> Submission Status :</label>
                    </div>
                    <div class="col-md-8 text-right">
                      <span class="f-s-14 f-w-400 text-black">{{SubmissionStatus}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-4 col-lg-4">
      <mat-card>
        <mat-card-content class="p-y-20">
          <div class="card rounded-4">
            <div class="card-body border-light p-b-10 p-x-8">
              <div class="text-center">
                <img src="../../../../../assets/images/documentation.png" *ngIf="SubmissionStatus == 'Success'" style="margin: 2px 0px !important;" width="48px" /> <!--Success image-->
                <h6 class="m-t-14 f-s-14 f-w-600" *ngIf="SubmissionStatus == 'Success'">Submitted Successfully</h6>

                <img src="../../../../../assets/images/cancel.png" width="48px" *ngIf="SubmissionStatus != 'Success'" /> <!--Failed image-->
                <h6 class="m-t-14 f-s-14 f-w-600" *ngIf="SubmissionStatus != 'Success'">Submitted Failed</h6>
              </div>
              <div class="row m-t-14">
                <div class="quick-access">
                  <ul class="p-0">
                    <li *ngIf="SubmissionStatus=='Failed'">
                      <button mat-flat-button class="btn btn-none px-3 m-0 mb-1" title="Show error" (click)="openErrorLog(template1,SubmissionId)">  <i-tabler name="file-alert" class="icon-20 m-r-10"></i-tabler> <span class="f-15"> Show Error </span> </button>
                    </li>
                    <li>
                      <button mat-flat-button class="btn btn-none px-3 m-0 mb-1" title="Print FBI Receipt" (click)="fbiReceiptDownload(modal,SubmissionId)"> <i-tabler name="printer" class="icon-18 m-r-10" style="color: #33678b;"></i-tabler> <span class="f-15"> Print FBI Receipt </span> </button>
                    </li>
                    <li>
                      <button mat-flat-button class="btn btn-none px-3 m-0 mb-1" title="Download FBI Receipt" (click)="fbiDownload(SubmissionId)"> <i-tabler name="download" class="icon-18 m-r-10" style="color: #33678b;"></i-tabler> <span class="f-15"> Download FBI Receipt </span> </button>
                    </li>
                    <li>
                      <button mat-flat-button class="btn btn-none px-3 m-0 mb-1" title="View in XML" (click)="openXmlDialog(SubmissionId)">  <i-tabler name="file" class="icon-18 m-r-10" style="color: #33678b;"></i-tabler> <span class="f-15"> View in XML </span> </button>
                    </li>
                    <li>
                      <button mat-flat-button class="btn btn-none px-3 m-0 mb-1" title="Download in XML" (click)="downloadZip(SubmissionId)"> <i-tabler name="file" class="icon-18 m-r-10" style="color: #33678b;"></i-tabler> <span class="f-15"> Download in XML </span> </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<!--<ng-template #template>
  <div class="m-20">
    <div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-16 f-w-600 d-block m-b-0 heading">
              Submissions Preview
            </h4>
            <p class="f-s-14 f-w-400 m-y-4">
              Preview of complete Submissions
            </p>
          </mat-card-title>
        </div>
        <div>
          <button class="text-center btn-close-dialog" (click)="closeModalPreview()" style="transform:scale(0.8)">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>

    <div class="row p-y-16">

    </div>

    <div class="row b-t-1 p-t-12">
      <div class="col-lg-12 text-right">
        <button mat-flat-button color="primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Print
          </div>
        </button>
      </div>
    </div>

  </div>
</ng-template>-->

<div class="spinner-container" *ngIf="ShowSpinnerTwo">
  <mat-spinner style="z-index:2000 !important;"></mat-spinner>
</div>
<ng-template #template>
  <div class="m-20">
    <div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center p-x-10">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-20 f-w-800 d-block m-b-0 heading p-l-8">
              Accounts Preview
            </h4>
            <!--<p class="f-s-14 f-w-400 m-y-4 p-l-8">
              Preview of Complete Accounts Package
            </p>-->
          </mat-card-title>
        </div>
        <div class="d-flex">
          <div>
            <button mat-flat-button color="primary" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasIXBRL','Spinnerthree')" [disabled]="!UserRoleAccess?.m1ExportorDownload">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Export iXBRL
              </div>
            </button>
          </div>
          <button class="text-center btn-close-dialog" (click)="closeModalPreview()" style="transform: scale(0.8); padding-top: 2px;">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>
    <!-- PDF Viewer -->
    <div class="row" style="margin-left: 0; margin-right: 0;">
      <div class="col-lg-12" style="height:750px;">
        <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
      </div>
    </div>
    <div class="row b-t-1 p-t-20">
      <!--<div class="col-lg-12 text-right">
        <button mat-flat-button color="primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="printer"></i-tabler> Print
          </div>
        </button>
      </div>-->
    </div>
  </div>
  <!-- Spinner overlay -->
  <div class="spinner-container" *ngIf="ShowSpinner3">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #templateExport>
  <div class="m-20">
    <div class="b-b-1 p-b-10">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <mat-card-title class="mat-mdc-card-title">
            <h4 class="f-s-16 f-w-600 d-block m-b-0 heading">
              Export  Accounts
            </h4>
            <p class="f-s-14 f-w-400 m-y-0">
              Select the Sections to Include in Your Export File.
            </p>
          </mat-card-title>
        </div>
        <div>
          <button class="text-center btn-close-dialog" style="transform:scale(0.8)" (click)="closeModalPreview()">
            <i-tabler name="X" class=""></i-tabler>
          </button>
        </div>
      </div>
    </div>

    <form [formGroup]="exportForm">
      <mat-card class="w-100 shadow-none" style="margin-bottom: 0px !important;">
        <mat-card-content class="p-y-4">
          <div class="row card-row p-b-16">
            <div class="col-lg-12">
              <h5 class="f-s-16 f-w-600 heading-text-clr">Include in Export</h5>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox [checked]="selectAll" (change)="toggleAll($event)">Select All</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="coverPage">Cover Page</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="contentsPage">Contents Page</mat-checkbox>
            </div>
          </div>

          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="referenceandAdministrationDetails">Reference and Administration Details</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="TrusteeAnnualReportStatus=='Completed'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="trusteesAnnualReport">Trustees' Annual Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="StatementofTrusteesResponsibility=='Completed'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementofTrusteesResponsibility">Statement of Trustees’ Responsibility </mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="report_Type != 'Auditor'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="independentExaminersReport">Independent Examiner's Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="report_Type == 'Auditor'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="auditorsReport">Auditor's Report</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementOfFinancialActivities">Statement of Financial Activities</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method=='Accruals (FRS 102 SORP)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="balanceSheet" [disabled]="BalanceSheetStatus=='Incompleted'">Balance Sheet</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method =='Cash (Receipts & Payments)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="receiptsandPayments">Receipts and Payments</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1" *ngIf="accounting_Method=='Cash (Receipts & Payments)'">
            <div class="col-lg-12">
              <mat-checkbox formControlName="statementofAssetsandLiabilities">Statement of Assets and Liabilities</mat-checkbox>
            </div>
          </div>
          <div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="notes">Notes</mat-checkbox>
            </div>
          </div>
          <!--<div class="row card-row p-y-4 b-t-1">
            <div class="col-lg-12">
              <mat-checkbox formControlName="directorsReport">Director's Report</mat-checkbox>
            </div>
          </div>-->
        </mat-card-content>
      </mat-card>
    </form>

    <div class="row b-t-1 p-t-12">
      <div class="col-lg-12 text-right">
        <button mat-flat-button class="btn-export-pdf m-r-10" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasPDF','')" [disabled]="!UserRoleAccess?.m1ExportorDownload || !isAnySectionSelected()">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="upload"></i-tabler> Export PDF
          </div>
        </button>
        <button mat-flat-button color="primary" style="height: 30px;" (click)="ExportasPDFandIXBRL('ExportasIXBRL','')" [disabled]="!UserRoleAccess?.m1ExportorDownload">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-0" name="upload"></i-tabler> Export iXBRL
          </div>
        </button>
      </div>
    </div>

  </div>
  <div class="spinner-container" *ngIf="ShowSpinnerinside">
    <mat-spinner style="z-index:2000 !important;"></mat-spinner>
  </div>
</ng-template>

<ng-template #template1>
  <mat-dialog-content class="f-s-14 lh-16 p-10">

    <div class="d-flex align-items-center justify-content-between p-b-16 m-b-20 b-b-1">
      <div class="p-t-4">
        <mat-label class="f-s-18 f-w-600 d-block m-b-8 heading">
          Error Log
        </mat-label>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-10">
        <button mat-flat-button color="primary" class="bg-success text-end">
          <div class="d-flex text-white" (click)="errorDownload(SubmissionId)">
            <i-tabler class="icon-18 m-r-4 text-white" name="download"></i-tabler><span class="f-s-14 text-white"> Download </span>
          </div>
        </button>
        <button mat-dialog-close class="text-center btn-close-dialog" style="transform:scale(0.8)">
          <i-tabler name="X" class=""></i-tabler>
        </button>
      </div>
    </div>

    <div>
      <p>Submission Errors</p>
      <div class="b-1 m-0" style="border-radius: 7px;">
        <div class="p-14" *ngFor="let data of errorList">
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Location
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text"> {{data.errorLocation}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Number
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text">{{data.errorNumber}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row align-items-center m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Type
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text"> {{data.errorType}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
          <div class="row m-b-12">
            <div class="col-md-4">
              <mat-label class="f-s-14 f-w-600 m-b-8" style="color: #10837b;">
                Error Text
              </mat-label>
            </div>
            <div class="col-md-8">
              <mat-label class="f-s-14 f-w-400 m-b-8 ">
                <div class="row">
                  <div class="col-sm-1">
                    <span class="m-r-14">:</span>
                  </div>
                  <div class="col-md-11">
                    <span class="error-text">{{data.errorText}}</span>
                  </div>
                </div>

              </mat-label>
            </div>
          </div>
        </div>
      </div>
    </div>

  </mat-dialog-content>
</ng-template>
<ng-template #modal>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-20">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>File by Internet Receipt</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12" style="height:750px;">
          <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<ng-template #xmlViewerTemplate>
  <mat-dialog-content class="f-s-14 lh-16 p-10" style="overflow: hidden;">

    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between p-b-16 m-b-20 b-b-1">
      <div class="p-t-4">
        <mat-label class="f-s-18 f-w-600 d-block m-b-8 heading">
          XML Data Viewer
        </mat-label>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-10">
        <button mat-flat-button color="primary" class="bg-success text-end" (click)="downloadZip(SubmissionId,true)">
          <div class="d-flex text-white">
            <i-tabler class="icon-18 m-r-4 text-white" name="download"></i-tabler>
            <span class="f-s-14 text-white">Download</span>
          </div>
        </button>
        <button mat-dialog-close class="text-center btn-close-dialog" style="transform:scale(0.8)">
          <i-tabler name="X"></i-tabler>
        </button>
      </div>
    </div>

    <!-- XML Content -->
    <div class="b-1" style="border-radius: 7px;">
      <div class="p-14">
        <!--<mat-label class="f-s-14 f-w-600 m-b-8 d-block" style="color: #346b88;">
          XML Content
        </mat-label>-->

        <div class="xml-viewer">
          <ace [mode]="mode"
               [theme]="theme"
               [options]="editorOptions"
               [value]="xmlDataRequest"
               [disabled]="true"
               style="height: 500px; width: 100%; border: 1px solid #ccc;"></ace>
        </div>

        <!--<ace-editor [(text)]="code"
              [mode]="mode"
              [theme]="theme"
              [options]="{ fontSize: '14px', showPrintMargin: false }"
              (textChanged)="onCodeChange($event.text)"
              style="min-height: 400px; width: 100%; border: 1px solid #ccc;"></ace-editor>-->
        <!-- Scrollable pretty XML -->
        <!--<pre class="xml-container">
          {{ xmlDataRequest }}
        </pre>-->

      </div>
    </div>



  </mat-dialog-content>
</ng-template>
<div class="spinner-container" *ngIf="this.ShowSpinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>













